var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBackGlobal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23845",
    "data-name": "Group 23845",
    transform: "translate(-392 -139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keyboard-right-arrow-button_1_",
    "data-name": "keyboard-right-arrow-button (1)",
    transform: "translate(401 146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42218",
    "data-name": "Path 42218",
    d: "M63.515,0,64.65,1.135l-3.73,3.73,3.73,3.73L63.515,9.73,58.65,4.865Z",
    transform: "translate(-58.65)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10974",
    "data-name": "Rectangle 10974",
    width: 24,
    height: 24,
    transform: "translate(392 139)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBackGlobal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_back_global.e5e9a3dd2133970a05013e2f31887f19.svg";